import { Link } from "react-router-dom";
import { specialList } from "@/utils/content";

export default function SpecialShowcase() {
  const items = specialList.slice(0, 3);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
      {items.map((item) => (
        <Link
          key={item.id}
          to={`/detail/${item.id}`}
          className="group relative block rounded-lg overflow-hidden bg-foreground-950 aspect-[16/10] cursor-pointer"
        >
          <img
            src={item.image}
            alt={item.title}
            title={`${item.title} 影视工厂专题`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500 opacity-90"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-5">
            <span className="inline-block px-2 py-0.5 rounded text-xs bg-accent-500 text-foreground-950">
              {item.genres[0]}
            </span>
            <h3 className="mt-3 font-heading text-xl md:text-2xl text-background-50 tracking-wide">
              {item.title}
            </h3>
            <p className="mt-2 text-xs md:text-sm text-background-300 line-clamp-2">
              {item.summary}
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
}